import React, { useState } from 'react';

const Skill = (props) => {


    return (
        <ul>
            <li className='flex flex-wrap gap-4 justify-between '>
                <img src={props.img} alt='skill image' className='w-[4rem] h-[4rem] select-none pointer-events-none' />
                <div>
                    <div className='flex justify-between gap-4 mb-1'>
                        <div className='flex'>
                            <div className='tracking-widest text-xl font-sen'>{props.skillName}</div>
                            <p className='self-end text-xs text-gray-400 ml-2'>{props.time}</p>
                        </div>
                        <p className={`font-sen text-lg font-bold tracking-[5px] ${(props.percentage >= 90) ? 'text-red-500' : 'text-black'}`}>{props.percentage}%</p>
                    </div>

                    <div id='skill-pasek' className={`h-4 w-[25rem]  rounded-full 
                    drop-shadow-[0_5px_15px_rgba(0,0,0,0.50)] bg-white select-none`}>
                        <div id='skill-pasek' className={`h-4 ${props.szer} rounded-full shadow-2xl transition-all duration-[1500ms] ease-in-out
                                                                bg-gradient-to-r from-[#392758] via-[#a33076] to-[#e64662]
                                                                `}>

                        </div>
                    </div>
                </div>
            </li>
        </ul>
    );
}

export default Skill;
